import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Link2, AlertTriangle } from "lucide-react";

// Market gateway connection wizard.
export const ConnectDialog = ({ b }) => {
  const { connectOpen, setConnectOpen, connForm, setConnForm, connecting, connect } = b;
  return (
    <Dialog open={connectOpen} onOpenChange={setConnectOpen}>
      <DialogContent data-testid="broker-connect-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Link2 className="h-4 w-4" /> Connect the market gateway</DialogTitle>
          <DialogDescription>Point Tharwy at your running Client Portal Gateway to route live orders.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="rounded-lg border p-3 space-y-2 text-xs text-muted-foreground bg-secondary/40">
            <div className="flex gap-2"><span className="font-semibold text-foreground">1.</span> Download & run the market gateway on a host reachable by this server.</div>
            <div className="flex gap-2"><span className="font-semibold text-foreground">2.</span> Log in (username + 2FA) in the gateway's browser session.</div>
            <div className="flex gap-2"><span className="font-semibold text-foreground">3.</span> Paste the gateway base URL and your account ID below.</div>
          </div>
          <div className="space-y-1.5">
            <Label>Gateway base URL</Label>
            <Input placeholder="https://your-host:5000/v1/api" value={connForm.base_url}
              onChange={(e) => setConnForm({ ...connForm, base_url: e.target.value })} data-testid="broker-connect-url" />
          </div>
          <div className="space-y-1.5">
            <Label>Account ID</Label>
            <Input placeholder="DU1234567 (paper) or U1234567 (live)" value={connForm.account_id}
              onChange={(e) => setConnForm({ ...connForm, account_id: e.target.value })} data-testid="broker-connect-account" />
          </div>
          <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-2.5 flex gap-2 text-xs">
            <AlertTriangle className="h-4 w-4 text-amber-600 shrink-0 mt-0.5" />
            <span className="text-muted-foreground">In this preview the gateway is unreachable, so the account stays in simulated mode. On a real deployment with a live gateway, this switches to live routing.</span>
          </div>
        </div>
        <DialogFooter>
          <Button variant="secondary" onClick={() => setConnectOpen(false)} disabled={connecting}>Cancel</Button>
          <Button onClick={connect} disabled={connecting || !connForm.base_url || !connForm.account_id} data-testid="broker-connect-submit">
            {connecting ? "Testing..." : "Test & connect"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
